import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Client } from 'src/app/models/client';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-loans',
  templateUrl: './loans.component.html',
  styleUrls: ['./loans.component.scss']
})
export class LoansComponent implements OnInit {

  @Input() client?: Client;

  loans?: any[];

  constructor(private httpClient: HttpClient, private authService: AuthService) { }

  ngOnInit(): void {
    this.httpClient.get('/api/clients/' + this.client!.id + '/loans',{
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('X-Access-Token', `Bearer ${this.authService.token}`),
    }).subscribe((result: any)=> {
      this.loans = result.loans;
    });
  }

}
